import { render, staticRenderFns } from "./ClientBreadcrumbs.vue?vue&type=template&id=18772fdf&"
import script from "./ClientBreadcrumbs.js?vue&type=script&lang=js&"
export * from "./ClientBreadcrumbs.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports